<template>

</template>

<script>

export default {
  name: "navbar"
};
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 125px;
  padding: .5rem 1rem;
  .navbar {
    min-height: 77px;
    transition: all .3s;
    background: #FFFFFF;
    .navbar-toggler {
      outline: none;
      width: 20px;
      height: 20px;
      cursor: pointer;
      transition: all .2s;
      position: relative;
      -webkit-align-self: center;
      align-self: center;
      .hamburger span {
        position: absolute;
        right: 0;
        width: 30px;
        height: 2px;
        border-right: 5px;
        background-color: #232323;
        &:nth-child(1) {
          top: 0px;
          transition: all .25s;
        }
        &:nth-child(2) {
          top: 8px;
          transition: all .25s;
        }
        &:nth-child(3) {
          top: 8px;
          transition: all .25s;
        }
        &:nth-child(4) {
          top: 16px;
          transition: all .25s;
        }
      }
    }
    .navbar-collapse {
      justify-content: flex-end;
      .nav-item {
        font-size: 12px;
        .nav-link {
          display: flex;
          -webkit-align-items: center;
          align-items: center;
          -webkit-justify-content: center;
          justify-content: center;
          outline: none;
          letter-spacing: 2px;
          color: #000000;
          padding: 1.177em 1.177em;
          transition: color .15s linear;
          position: relative;
          &:hover {
            color: #0d7658;

            &:before {
              width: 100%;
            }
          }
          &:before {
            display: block;
            width: 0;
            height: 3px;
            background: #0d7658;
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            transition: width 200ms linear,left 200ms linear;
          }
        }
      }
      .navbar-buttons {
        text-align: center;
        margin: 1rem .5rem;
        .btn-primary {
          background: #0d7658;
          color: #FFFFFF;
          padding: 1rem 3rem;
          line-height: 1.25;
          font-size: 12.8px;
          text-transform: uppercase;
          letter-spacing: .4px;
          font-weight: 600;
          border: none;
          border-radius: 3px;
          text-decoration: none;
          transition: background .2s linear;
          margin: 0 auto;
          &:hover {
            background: #231f20;
          }
          &:focus {
            background: #231f20;
          }
        }
      }
    }
  }
  .navbar-toggler[aria-expanded="true"] {
    .hamburger span:nth-child(1),
    .hamburger span:nth-child(4) {
      opacity: 0;
    }
    .hamburger span:nth-child(2) {
      transform: rotate(45deg);
    }
    .hamburger span:nth-child(3) {
      transform: rotate(-45deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue